const TWELVE_HOURS_MS = 12 * 60 * 60 * 1000

export function isUpcomingMatch(match, now = Date.now()) {
  const kickoffMs = new Date(match.kickoffTime).getTime()
  return Number.isFinite(kickoffMs) && now < kickoffMs
}

export function getMissingGuesses(matches, myGuessByMatch, now = Date.now()) {
  return matches.filter((match) => !myGuessByMatch[match.id] && isUpcomingMatch(match, now))
}

export function getMissingGuessesWithinHours(matches, myGuessByMatch, hours = 12, now = Date.now()) {
  const windowEnd = now + hours * 60 * 60 * 1000
  return getMissingGuesses(matches, myGuessByMatch, now).filter((match) => {
    const kickoffMs = new Date(match.kickoffTime).getTime()
    return kickoffMs <= windowEnd
  })
}

export function countMissingGuesses(matches, myGuessByMatch, now = Date.now()) {
  return getMissingGuesses(matches, myGuessByMatch, now).length
}

export function formatMissingGuessesLabel(count) {
  if (count === 1) return '1 mangler'
  return `${count} mangler`
}

export function buildMissingGuessesBannerText({ totalMissing, urgentMissing }) {
  if (totalMissing <= 0) return null
  if (urgentMissing > 0) {
    const urgentLabel = urgentMissing === 1 ? '1 kamp' : `${urgentMissing} kampe`
    if (totalMissing === urgentMissing) {
      return `Du mangler gæt på ${urgentLabel} der starter inden 12 timer.`
    }
    const rest = totalMissing - urgentMissing
    const restLabel = rest === 1 ? '1 anden kamp' : `${rest} andre kampe`
    return `Du mangler gæt på ${urgentLabel} der starter inden 12 timer — og ${restLabel}.`
  }
  const totalLabel = totalMissing === 1 ? '1 kommende kamp' : `${totalMissing} kommende kampe`
  return `Du mangler gæt på ${totalLabel}.`
}

export { TWELVE_HOURS_MS }
